const cpf = (cpf: string) => cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/ig, '$1.$2.$3-$4');
const cellphone = (number: string) => number.replace(/(\d{2})(\d{4,5})(\d{4})/ig, '($1) $2-$3');
const rg = (rg: string) => rg.replace(/(\d{2})(\d{3})(\d{3})(\d{1,2})/ig, '$1.$2.$3-$4');


export {
    cpf,
    cellphone, 
    rg
};